// extracted by mini-css-extract-plugin
export default {"closeButtom":"Chat_closeButtom__JVJhJ","transferChatButton":"Chat_transferChatButton__rvOM9","chatContainer":"Chat_chatContainer__wO3za"};